"use client";
import { jsx as a } from "react/jsx-runtime";
const e = () => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    focusable: "false",
    height: "100%",
    width: "100%",
    children: /* @__PURE__ */ a("g", { children: /* @__PURE__ */ a("path", { d: "M17.676 11.02a.922.922 0 1 1 1.304 1.304L16.304 15l2.676 2.677c.33.33.358.848.082 1.21l-.082.094a.922.922 0 0 1-1.304 0l-2.677-2.676-2.675 2.676a.922.922 0 0 1-1.21.082l-.094-.082a.922.922 0 0 1 0-1.304l2.675-2.677-2.675-2.675a.922.922 0 0 1-.082-1.21l.082-.094a.922.922 0 0 1 1.304 0L15 13.695ZM9.5 1a8.5 8.5 0 0 1 8.486 8h-4.013A4.5 4.5 0 1 0 9 13.973v4.013A8.5 8.5 0 0 1 9.5 1ZM6 14a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM3 9.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM15 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM5 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm5-2a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z" }) })
  }
);
export {
  e as IconBearingFault
};
